import { jobLists } from "character";
import { EorzeaDataType, GameData, Job, Market, RelicData } from "enums";
import { Info } from "types/game";

export const shbItems = {
	[GameData.Item.THAVNAIRIAN_SCALEPOWDER]: {
		name: GameData.Item.THAVNAIRIAN_SCALEPOWDER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.AURIANA, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.HISMENA, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_LIMSA, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_UlDAH, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_GRIDANIA, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
				{ shop: GameData.Shop.ROWENA_REP_FOUNDATION, cost: [{ price: 250, currency: GameData.Currency.TOMESTONE_COMMON }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_RESISTANCE, RelicData.Step.SCALEPOWDER, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 4,
			},
		],
	},
	[GameData.Item.TORTURED_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.TORTURED_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.COERTHAS_WESTERN_HIGHLANDS, GameData.MapLocation.SEA_OF_CLOUDS, GameData.MapLocation.BOZJA_SOUTH],
				trials: [GameData.MapLocation.BOZJA_SOUTH],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Step.MEMORY, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.SORROWFUL_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.SORROWFUL_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.DRAVANIAN_FORELANDS, GameData.MapLocation.CHURNING_MISTS, GameData.MapLocation.BOZJA_MIDDLE],
				trials: [GameData.MapLocation.BOZJA_MIDDLE],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Step.MEMORY, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.HARROWING_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.HARROWING_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.DRAVANIAN_HINTERLANDS, GameData.MapLocation.AZYS_LLA, GameData.MapLocation.BOZJA_NORTH],
				trials: [GameData.MapLocation.BOZJA_NORTH],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_RESISTANCE, RelicData.Step.MEMORY, RelicData.Task.TASK_3],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.BITTER_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.BITTER_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "Any level 60 dungeon" },
				{ element: "p", text: "Leveling Roulette (Only once per day)" },
				{ element: "p", text: "Activities in the Bozjan Southern Front" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_RECOLLECTION, RelicData.Step.RESIST, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 6,
			},
		],
	},
	[GameData.Item.LOATHSOME_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.LOATHSOME_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				trials: [GameData.MapLocation.BOZJA],
				raids: [GameData.Raid.LABYRINTH_OF_ANCIENTS, GameData.Raid.SYRCUS_TOWER, GameData.Raid.WORLD_OF_DARKNESS, GameData.Raid.CASTRUM_LACUS_LITORE],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_LAWS_ORDER, RelicData.Step.CHANGE_OF_ARMS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 15,
			},
		],
	},
	[GameData.Item.HAUNTING_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.HAUNTING_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				raids: [GameData.Raid.VOID_ARK, GameData.Raid.MHACH, GameData.Raid.DUN_SCAITH],
				fates: [GameData.MapLocation.FRINGES, GameData.MapLocation.PEAKS, GameData.MapLocation.LOCHS],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Step.REMEMBERS, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 18,
			},
		],
	},
	[GameData.Item.VEXATIOUS_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.VEXATIOUS_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				raids: [GameData.Raid.RABANASTRE, GameData.Raid.RIDORANA, GameData.Raid.ORBONNE],
				fates: [GameData.MapLocation.RUBY_SEA, GameData.MapLocation.YANXIA, GameData.MapLocation.AZIM_STEPPE],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Step.REMEMBERS, RelicData.Task.TASK_2],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 18,
			},
		],
	},
	[GameData.Item.TIMEWORN_ARTIFACTS]: {
		name: GameData.Item.TIMEWORN_ARTIFACTS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: { raids: [GameData.Raid.DELUBRUM_REGINAE] },
			other: [{ element: "p", text: "Palace of the Dead" }],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_AUGMENTED_LAWS_ORDER, RelicData.Step.PATH, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 15,
			},
		],
	},
	[GameData.Item.COMPACT_AXLE]: {
		name: GameData.Item.COMPACT_AXLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.ZADNOR_SOUTH],
				raids: [GameData.Raid.ALEXANDER_1, GameData.Raid.ALEXANDER_2, GameData.Raid.ALEXANDER_5, GameData.Raid.ALEXANDER_6, GameData.Raid.ALEXANDER_9, GameData.Raid.ALEXANDER_10],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.SPARE_PARTS, RelicData.Task.TASK_1],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.COMPACT_SPRING]: {
		name: GameData.Item.COMPACT_SPRING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				trials: [GameData.MapLocation.ZADNOR_SOUTH],
				raids: [GameData.Raid.ALEXANDER_3, GameData.Raid.ALEXANDER_4, GameData.Raid.ALEXANDER_7, GameData.Raid.ALEXANDER_8, GameData.Raid.ALEXANDER_11, GameData.Raid.ALEXANDER_12],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.SPARE_PARTS, RelicData.Task.TASK_2],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.BATTLES_FOR_THE_REALM]: {
		name: GameData.Item.BATTLES_FOR_THE_REALM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.ZADNOR_MIDDLE],
				raids: [GameData.Raid.OMEGA_1, GameData.Raid.OMEGA_2, GameData.Raid.OMEGA_5, GameData.Raid.OMEGA_6, GameData.Raid.OMEGA_9, GameData.Raid.OMEGA_10],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.STORY, RelicData.Task.TASK_1],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.BEYOND_THE_RIFT]: {
		name: GameData.Item.BEYOND_THE_RIFT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				trials: [GameData.MapLocation.ZADNOR_MIDDLE],
				raids: [GameData.Raid.OMEGA_3, GameData.Raid.OMEGA_4, GameData.Raid.OMEGA_7, GameData.Raid.OMEGA_8, GameData.Raid.OMEGA_11, GameData.Raid.OMEGA_12],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.STORY, RelicData.Task.TASK_2],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.BLEAK_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.BLEAK_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				fates: [GameData.MapLocation.ZADNOR_NORTH],
				raids: [GameData.Raid.EDEN_1, GameData.Raid.EDEN_2, GameData.Raid.EDEN_5, GameData.Raid.EDEN_6, GameData.Raid.EDEN_9, GameData.Raid.EDEN_10],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.FOND_MEMORY, RelicData.Task.TASK_1],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.LURID_MEMORY_OF_THE_DYING]: {
		name: GameData.Item.LURID_MEMORY_OF_THE_DYING,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: {
				trials: [GameData.MapLocation.ZADNOR_NORTH],
				raids: [GameData.Raid.EDEN_3, GameData.Raid.EDEN_4, GameData.Raid.EDEN_7, GameData.Raid.EDEN_8, GameData.Raid.EDEN_11, GameData.Raid.EDEN_12],
			},
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.FOND_MEMORY, RelicData.Task.TASK_2],
				jobs: [Job.PLD],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.RAW_EMOTION]: {
		name: GameData.Item.RAW_EMOTION,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			duties: { raids: [GameData.Raid.DALRIADA, GameData.Raid.DELUBRUM_REGINAE] },
			other: [
				{ element: "p", text: "1 per level 70 Dungeon" },
				{ element: "p", text: "1 per 10 floors of Heaven-on-High (This is not 100% - Chances increases on higher floors)" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.WEAPON, RelicData.Group.WEAPON_RESISTANCE, RelicData.Part.WEAPON_BLADE, RelicData.Step.IRRESISTIBLE, RelicData.Task.TASK_1],
				jobs: jobLists.relic[RelicData.Group.WEAPON_RESISTANCE],
				qtyPerJob: 15,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PETRIFIED_ORB_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_PETRIFIED_ORB_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_PETRIFIED_ORB_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "fa41b2bbb4a",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_PETRIFIED_LOG, qty: 1 },
						{ item: GameData.Item.WHITE_ASH_LOG, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PETRIFIED_LOG]: {
		name: GameData.Item.ODDLY_SPECIFIC_PETRIFIED_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.WHITE_ASH_LOG]: {
		name: GameData.Item.WHITE_ASH_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27685 },
			gathering: [{ found: { location: GameData.MapLocation.WOVEN_OATH, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_RIVETS_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_RIVETS_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_RIVETS_HQ,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "c3dc42e6cef",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_IRON_SAND, qty: 1 },
						{ item: GameData.Item.MANASILVER_SAND, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_IRON_SAND]: {
		name: GameData.Item.ODDLY_SPECIFIC_IRON_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.MANASILVER_SAND]: {
		name: GameData.Item.MANASILVER_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27699 },
			gathering: [{ found: { location: GameData.MapLocation.LOZATLS_CONQUEST, x: 0, y: 0 }, method: GameData.GatherMethod.QUARRYING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_WIRE_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_WIRE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_WIRE_HQ,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "7357b87dbbd",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_IRON_ORE, qty: 1 },
						{ item: GameData.Item.MANASILVER_SAND, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_IRON_ORE]: {
		name: GameData.Item.ODDLY_SPECIFIC_IRON_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_WHETSTONE_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_WHETSTONE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_WHETSTONE_HQ,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "61e2aac21db",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_UNCUT_GEMSTONE, qty: 1 },
						{ item: GameData.Item.MANASILVER_SAND, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_UNCUT_GEMSTONE]: {
		name: GameData.Item.ODDLY_SPECIFIC_UNCUT_GEMSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_LEATHER_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_LEATHER_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_LEATHER_HQ,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "9571475cb4d",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SKIN, qty: 1 },
						{ item: GameData.Item.ATROCIRAPTOR_SKIN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SKIN]: {
		name: GameData.Item.ODDLY_SPECIFIC_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ATROCIRAPTOR_SKIN]: {
		name: GameData.Item.ATROCIRAPTOR_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27734 },
			enemies: [GameData.Enemy.ATROCIRAPTOR],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_MOONBEAM_SILK_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_MOONBEAM_SILK_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_MOONBEAM_SILK_HQ,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "1c59d8f8897",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_COTTON, qty: 1 },
						{ item: GameData.Item.PIXIE_FLOSS_BOLL, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_COTTON]: {
		name: GameData.Item.ODDLY_SPECIFIC_COTTON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.PIXIE_FLOSS_BOLL]: {
		name: GameData.Item.PIXIE_FLOSS_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27753 },
			gathering: [{ found: { location: GameData.MapLocation.DELIBERATING_DOLL, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_SYNTHETIC_RESIN_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_SYNTHETIC_RESIN_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SYNTHETIC_RESIN_HQ,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "920cd90653f",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_QUARTZ, qty: 1 },
						{ item: GameData.Item.VAMPIRE_VINE_SAP, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_QUARTZ]: {
		name: GameData.Item.ODDLY_SPECIFIC_QUARTZ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.VAMPIRE_VINE_SAP]: {
		name: GameData.Item.VAMPIRE_VINE_SAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27774 },
			shops: [
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.NACILLE, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			enemies: [GameData.Enemy.VAMPIRE_VINE],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_SEED_EXTRACT_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_SEED_EXTRACT_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SEED_EXTRACT_HQ,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "2bd24d1a30b",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SEEDS, qty: 1 },
						{ item: GameData.Item.HIGHLAND_SPRING_WATER, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 20,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SEEDS]: {
		name: GameData.Item.ODDLY_SPECIFIC_SEEDS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.HIGHLAND_SPRING_WATER]: {
		name: GameData.Item.HIGHLAND_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27968 },
			gathering: [{ found: { location: GameData.MapLocation.BOOKMANS_SHELVES, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_OBSIDIAN]: {
		name: GameData.Item.ODDLY_SPECIFIC_OBSIDIAN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.OK_VUNDU_VANA, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.RED_RIM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 340,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_MINERAL_SAND]: {
		name: GameData.Item.ODDLY_SPECIFIC_MINERAL_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.OK_VUNDU_VANA, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.RED_RIM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 120,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_LATEX]: {
		name: GameData.Item.ODDLY_SPECIFIC_LATEX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.WHILOM_RIVER, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.WHALES_CROWN, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 340,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_FOSSIL_DUST]: {
		name: GameData.Item.ODDLY_SPECIFIC_FOSSIL_DUST,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.WHILOM_RIVER, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.WHALES_CROWN, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 120,
			},
		],
	},
	[GameData.Item.THINKERS_CORAL]: {
		name: GameData.Item.THINKERS_CORAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.THINKERS_CORAL, hole: GameData.Fishing.THALIAK_RIVER, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSTEEL_1, RelicData.Step.SKYSTEEL_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 40,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SHAFT_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_SHAFT_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SHAFT_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "9f25a343d79",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_PETRIFIED_LOG, qty: 1 },
						{ item: GameData.Item.SANDTEAK_LUMBER, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.SANDTEAK_LUMBER]: {
		name: GameData.Item.SANDTEAK_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SANDTEAK_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 76,
					lodestoneID: "ec4fcd3ac53",
					itemsRequired: [
						{ item: GameData.Item.SANDTEAK_LOG, qty: 4 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27692 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_FITTING_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_FITTING_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_FITTING_HQ,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "668a6a07a53",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_IRON_SAND, qty: 1 },
						{ item: GameData.Item.TITANBRONZE_INGOT, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.TITANBRONZE_INGOT]: {
		name: GameData.Item.TITANBRONZE_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.TITANBRONZE_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 76,
					lodestoneID: "058898fed1e",
					itemsRequired: [
						{ item: GameData.Item.TITANCOPPER_ORE, qty: 4 },
						{ item: GameData.Item.TITANIUM_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
				{
					itemMade: GameData.Item.TITANBRONZE_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 76,
					lodestoneID: "65cd046a22e",
					itemsRequired: [
						{ item: GameData.Item.TITANCOPPER_ORE, qty: 4 },
						{ item: GameData.Item.TITANIUM_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27713 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_CHAINMAIL_SHEET_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_CHAINMAIL_SHEET_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_CHAINMAIL_SHEET_HQ,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "af91eefbcf4",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_IRON_ORE, qty: 1 },
						{ item: GameData.Item.TITANBRONZE_INGOT, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_GEMSTONE_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_GEMSTONE_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_GEMSTONE_HQ,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "a4f2e1f8fc2",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_UNCUT_GEMSTONE, qty: 1 },
						{ item: GameData.Item.TUFF_WHETSTONE, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.TUFF_WHETSTONE]: {
		name: GameData.Item.TUFF_WHETSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.TUFF_WHETSTONE,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 76,
					lodestoneID: "28b74a11836",
					itemsRequired: [
						{ item: GameData.Item.VOLCANIC_TUFF, qty: 3 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27804 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_VELLUM_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_VELLUM_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_VELLUM_HQ,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "bb8187cd885",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SKIN, qty: 1 },
						{ item: GameData.Item.ZONURE_LEATHER, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.ZONURE_LEATHER]: {
		name: GameData.Item.ZONURE_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ZONURE_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 76,
					lodestoneID: "7f12bd918f1",
					itemsRequired: [
						{ item: GameData.Item.ZONURE_SKIN, qty: 4 },
						{ item: GameData.Item.YELLOW_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27741 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_VELVET_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_VELVET_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_VELVET_HQ,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "93c26191232",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_COTTON, qty: 1 },
						{ item: GameData.Item.OVIM_WOOL, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.OVIM_WOOL]: {
		name: GameData.Item.OVIM_WOOL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.OVIM_WOOL,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 76,
					lodestoneID: "b10b1891d15",
					itemsRequired: [
						{ item: GameData.Item.OVIM_WOOL_YARN, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 4 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27754 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_GLASS_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_GLASS_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_GLASS_HQ,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 0,
					lodestoneID: "b506262a9b9",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_QUARTZ, qty: 1 },
						{ item: GameData.Item.REFINED_NATRON, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.REFINED_NATRON]: {
		name: GameData.Item.REFINED_NATRON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.REFINED_NATRON,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 76,
					lodestoneID: "ea6ca0bd4a6",
					itemsRequired: [
						{ item: GameData.Item.EXTRA_EFFERVESCENT_WATER, qty: 1 },
						{ item: GameData.Item.ALA_MHIGAN_SALT_CRYSTAL, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27777 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_SEED_FLOUR_HQ]: {
		name: GameData.Item.ODDLY_SPECIFIC_SEED_FLOUR_HQ,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SEED_FLOUR_HQ,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "d2edc823c5c",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SEEDS, qty: 1 },
						{ item: GameData.Item.NIGHT_VINEGAR, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 30,
			},
		],
	},
	[GameData.Item.NIGHT_VINEGAR]: {
		name: GameData.Item.NIGHT_VINEGAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.NIGHT_VINEGAR,
					qtyMade: 3,
					crafter: Job.CUL,
					level: 75,
					lodestoneID: "f643e83f867",
					itemsRequired: [
						{ item: GameData.Item.ROYAL_GRAPES, qty: 5 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27843 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_DARK_MATTER]: {
		name: GameData.Item.ODDLY_SPECIFIC_DARK_MATTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.MOURN, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.DAGGERS, x: 0, y: 0 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 510,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_STRIKING_STONE]: {
		name: GameData.Item.ODDLY_SPECIFIC_STRIKING_STONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.MOURN, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.DAGGERS, x: 0, y: 0 }, method: GameData.GatherMethod.QUARRYING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_AMBER]: {
		name: GameData.Item.ODDLY_SPECIFIC_AMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.FOUR_ARMS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.ASHPOOL, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 510,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_BAUBLE]: {
		name: GameData.Item.ODDLY_SPECIFIC_BAUBLE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.FOUR_ARMS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.ASHPOOL, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.DRAGONSPINE]: {
		name: GameData.Item.DRAGONSPINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.DRAGONSPINE, hole: GameData.Fishing.DRAGONSPIT, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_DRAGONSUNG, RelicData.Step.DRAGONSUNG_ITEMS, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_CEDAR_LUMBER]: {
		name: GameData.Item.ODDLY_SPECIFIC_CEDAR_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_CEDAR_LUMBER,
					qtyMade: 1, collectable: true,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "4846abb678f",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_CEDAR_LOG, qty: 1 },
						{ item: GameData.Item.LIGNUM_VITAE_LOG, qty: 2 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_CEDAR_LOG]: {
		name: GameData.Item.ODDLY_SPECIFIC_CEDAR_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.LIGNUM_VITAE_LOG]: {
		name: GameData.Item.LIGNUM_VITAE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.HARE_AMONG_GIANTS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: 27687 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_IRON_NAILS]: {
		name: GameData.Item.ODDLY_SPECIFIC_IRON_NAILS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_IRON_NAILS,
					qtyMade: 1, collectable: true,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "cbc0a3d606f",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_COERTHAN_IRON_ORE, qty: 1 },
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 2 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_COERTHAN_IRON_ORE]: {
		name: GameData.Item.ODDLY_SPECIFIC_COERTHAN_IRON_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.DIMYTHRITE_ORE]: {
		name: GameData.Item.DIMYTHRITE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.CHURCH_OF_FIRST_LIGHT, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }],
			markets: { [Market.UNIVERSALIS]: 27703 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_MYTHRIL_RINGS]: {
		name: GameData.Item.ODDLY_SPECIFIC_MYTHRIL_RINGS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_MYTHRIL_RINGS,
					qtyMade: 1, collectable: true,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "b59c21a3b35",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_MYTHRITE_SAND, qty: 1 },
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 2 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_MYTHRITE_SAND]: {
		name: GameData.Item.ODDLY_SPECIFIC_MYTHRITE_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_SILVER_NUGGET]: {
		name: GameData.Item.ODDLY_SPECIFIC_SILVER_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SILVER_NUGGET,
					qtyMade: 1, collectable: true,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "21263e04c67",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SILVER_ORE, qty: 1 },
						{ item: GameData.Item.DIMYTHRITE_SAND, qty: 2 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SILVER_ORE]: {
		name: GameData.Item.ODDLY_SPECIFIC_SILVER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.DIMYTHRITE_SAND]: {
		name: GameData.Item.DIMYTHRITE_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.MOUNT_BIRAN_MINES, x: 17, y: 12 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: 27702 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_GAGANASKIN_STRAP]: {
		name: GameData.Item.ODDLY_SPECIFIC_GAGANASKIN_STRAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_GAGANASKIN_STRAP,
					qtyMade: 1, collectable: true,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "7b674b922d3",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_GAGANA_SKIN, qty: 1 },
						{ item: GameData.Item.YELLOW_ALUMEN, qty: 2 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_GAGANA_SKIN]: {
		name: GameData.Item.ODDLY_SPECIFIC_GAGANA_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.YELLOW_ALUMEN]: {
		name: GameData.Item.YELLOW_ALUMEN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.INN_AT_JOURNEYS_HEAD, x: 30, y: 23 }, method: GameData.GatherMethod.QUARRYING }],
			markets: { [Market.UNIVERSALIS]: 27817 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_CLOTH]: {
		name: GameData.Item.ODDLY_SPECIFIC_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_CLOTH,
					qtyMade: 1, collectable: true,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "bd3029cb2f6",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_FLEECE, qty: 1 },
						{ item: GameData.Item.DWARVEN_COTTON_BOLL, qty: 2 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_FLEECE]: {
		name: GameData.Item.ODDLY_SPECIFIC_FLEECE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.DWARVEN_COTTON_BOLL]: {
		name: GameData.Item.DWARVEN_COTTON_BOLL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.SCREE, x: 14, y: 14 }, method: GameData.GatherMethod.HARVESTING }],
			markets: { [Market.UNIVERSALIS]: 27759 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_GLUE]: {
		name: GameData.Item.ODDLY_SPECIFIC_GLUE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_GLUE,
					qtyMade: 1, collectable: true,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "cccb30edae4",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SAP, qty: 1 },
						{ item: GameData.Item.VAMPIRE_CUP_VINE, qty: 2 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SAP]: {
		name: GameData.Item.ODDLY_SPECIFIC_SAP,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.VAMPIRE_CUP_VINE]: {
		name: GameData.Item.VAMPIRE_CUP_VINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.VAMPIRE_CUP],
			shops: [
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.NACILLE, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 1, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
			markets: { [Market.UNIVERSALIS]: 27773 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_OIL]: {
		name: GameData.Item.ODDLY_SPECIFIC_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_OIL,
					qtyMade: 1, collectable: true,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "1d374634082",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_ALOE, qty: 1 },
						{ item: GameData.Item.FRANTOIO, qty: 2 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 18, maxQtyPerJob: 45,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_ALOE]: {
		name: GameData.Item.ODDLY_SPECIFIC_ALOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 20, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 30, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.FRANTOIO]: {
		name: GameData.Item.FRANTOIO,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [{ found: { location: GameData.MapLocation.CHILIAD, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }],
			markets: { [Market.UNIVERSALIS]: 27820 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_SCHORL]: {
		name: GameData.Item.ODDLY_SPECIFIC_SCHORL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.DRAGONS_STRUGGLE, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.PAUPERS_LODE, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 500,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_LANDBORNE_AETHERSAND]: {
		name: GameData.Item.ODDLY_SPECIFIC_LANDBORNE_AETHERSAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.DRAGONS_STRUGGLE, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.PAUPERS_LODE, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_DARK_CHESTNUT_LOG]: {
		name: GameData.Item.ODDLY_SPECIFIC_DARK_CHESTNUT_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.DESTROYER_LOCHS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.VALLEY_OF_THE_FALLEN_RAINBOW, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 500,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_LEAFBORNE_AETHERSAND]: {
		name: GameData.Item.ODDLY_SPECIFIC_LEAFBORNE_AETHERSAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.DESTROYER_LOCHS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.VALLEY_OF_THE_FALLEN_RAINBOW, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 180,
			},
		],
	},
	[GameData.Item.PETAL_SHELL]: {
		name: GameData.Item.PETAL_SHELL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.PETAL_SHELL, hole: GameData.Fishing.PLUM_SPRING, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_AUGMENTED_DRAGONSUNG, RelicData.Step.BASIC_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_CEDAR_PLANK]: {
		name: GameData.Item.ODDLY_SPECIFIC_CEDAR_PLANK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_CEDAR_PLANK,
					qtyMade: 1, collectable: true,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "291a61b19e4",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_CEDAR_LOG, qty: 1 },
						{ item: GameData.Item.LIGNUM_VITAE_LUMBER, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.LIGNUM_VITAE_LUMBER]: {
		name: GameData.Item.LIGNUM_VITAE_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.LIGNUM_VITAE_LUMBER,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 78,
					lodestoneID: "90cb971f86d",
					itemsRequired: [
						{ item: GameData.Item.LIGNUM_VITAE_LOG, qty: 4 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27693 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_IRON_INGOT]: {
		name: GameData.Item.ODDLY_SPECIFIC_IRON_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_IRON_INGOT,
					qtyMade: 1, collectable: true,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "5e4bd73a73d",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_COERTHAN_IRON_ORE, qty: 1 },
						{ item: GameData.Item.DWARVEN_MYTHRIL_INGOT, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.DWARVEN_MYTHRIL_INGOT]: {
		name: GameData.Item.DWARVEN_MYTHRIL_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DWARVEN_MYTHRIL_INGOT,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 78,
					lodestoneID: "47184e5257d",
					itemsRequired: [
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 4 },
						{ item: GameData.Item.MYTHRITE_ORE, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
				{
					itemMade: GameData.Item.DWARVEN_MYTHRIL_INGOT,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 78,
					lodestoneID: "95be9660f8d",
					itemsRequired: [
						{ item: GameData.Item.DIMYTHRITE_ORE, qty: 4 },
						{ item: GameData.Item.MYTHRITE_ORE, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27714 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_MYTHRIL_PLATE]: {
		name: GameData.Item.ODDLY_SPECIFIC_MYTHRIL_PLATE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_MYTHRIL_PLATE,
					qtyMade: 1, collectable: true,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "e70abfd01e5",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_MYTHRITE_SAND, qty: 1 },
						{ item: GameData.Item.DWARVEN_MYTHRIL_INGOT, qty: 1 },
						{ item: GameData.Item.ICE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_SILVER_INGOT]: {
		name: GameData.Item.ODDLY_SPECIFIC_SILVER_INGOT,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_SILVER_INGOT,
					qtyMade: 1, collectable: true,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "a2c56402703",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SILVER_ORE, qty: 1 },
						{ item: GameData.Item.DWARVEN_MYTHRIL_NUGGET, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.DWARVEN_MYTHRIL_NUGGET]: {
		name: GameData.Item.DWARVEN_MYTHRIL_NUGGET,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DWARVEN_MYTHRIL_NUGGET,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 78,
					lodestoneID: "eb9829c05b4",
					itemsRequired: [
						{ item: GameData.Item.DIMYTHRITE_SAND, qty: 4 },
						{ item: GameData.Item.MYTHRITE_SAND, qty: 1 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27715 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_GAGANA_LEATHER]: {
		name: GameData.Item.ODDLY_SPECIFIC_GAGANA_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_GAGANA_LEATHER,
					qtyMade: 1, collectable: true,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "e177e170ac8",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_GAGANA_SKIN, qty: 1 },
						{ item: GameData.Item.SEA_SWALLOW_LEATHER, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.SEA_SWALLOW_LEATHER]: {
		name: GameData.Item.SEA_SWALLOW_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.SEA_SWALLOW_LEATHER,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 78,
					lodestoneID: "cb1c3b94199",
					itemsRequired: [
						{ item: GameData.Item.SEA_SWALLOW_SKIN, qty: 4 },
						{ item: GameData.Item.YELLOW_ALUMEN, qty: 1 },
						{ item: GameData.Item.EARTH_CRYSTAL, qty: 7 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27742 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_UNDYED_WOOLEN_CLOTH]: {
		name: GameData.Item.ODDLY_SPECIFIC_UNDYED_WOOLEN_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_UNDYED_WOOLEN_CLOTH,
					qtyMade: 1, collectable: true,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "3e98b055df8",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_FLEECE, qty: 1 },
						{ item: GameData.Item.DWARVEN_COTTON, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WIND_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.DWARVEN_COTTON]: {
		name: GameData.Item.DWARVEN_COTTON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.DWARVEN_COTTON,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 78,
					lodestoneID: "da17b5d43e4",
					itemsRequired: [
						{ item: GameData.Item.DWARVEN_COTTON_THREAD, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 4 },
					],
				},
			],
			markets: { [Market.UNIVERSALIS]: 27757 },
		},
		used: [],
	},
	[GameData.Item.ODDLY_SPECIFIC_RUBBER]: {
		name: GameData.Item.ODDLY_SPECIFIC_RUBBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_RUBBER,
					qtyMade: 1, collectable: true,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "48b151c003f",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_SAP, qty: 1 },
						{ item: GameData.Item.REFINED_NATRON, qty: 1 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PASTE]: {
		name: GameData.Item.ODDLY_SPECIFIC_PASTE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_SPECIFIC_PASTE,
					qtyMade: 1, collectable: true,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "e7d9c343ab6",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_SPECIFIC_ALOE, qty: 1 },
						{ item: GameData.Item.NIGHT_VINEGAR, qty: 1 },
						{ item: GameData.Item.FIRE_CRYSTAL, qty: 7 },
						{ item: GameData.Item.WATER_CRYSTAL, qty: 7 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 21, maxQtyPerJob: 53,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ORE]: {
		name: GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.COOLING_STATION, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.AQUEDUCT, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 600,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ASPHALTUM]: {
		name: GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_ASPHALTUM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.COOLING_STATION, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
				{ found: { location: GameData.MapLocation.AQUEDUCT, x: 0, y: 0 }, method: GameData.GatherMethod.MINING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 200,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_LOG]: {
		name: GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.HYPERSTELLAR_DOWNCONVERTER, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.PAPPUS_TREE, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 600,
			},
		],
	},
	[GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_RESIN]: {
		name: GameData.Item.ODDLY_SPECIFIC_PRIMORDIAL_RESIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			gathering: [
				{ found: { location: GameData.MapLocation.HYPERSTELLAR_DOWNCONVERTER, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
				{ found: { location: GameData.MapLocation.PAPPUS_TREE, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 200,
			},
		],
	},
	[GameData.Item.ALLAGAN_HUNTER]: {
		name: GameData.Item.ALLAGAN_HUNTER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.ALLAGAN_HUNTER, hole: GameData.Fishing.ALPHA_QUADRANT, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYSUNG, RelicData.Step.VISCOUS_GOBBIEGOO, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 70,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_PINE_LUMBER]: {
		name: GameData.Item.ODDLY_DELICATE_PINE_LUMBER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_PINE_LUMBER,
					qtyMade: 1, collectable: true,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "3e98b055df8",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_PINE_LOG, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_LOG, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_BARBGRASS, qty: 5 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_PINE_LOG]: {
		name: GameData.Item.ODDLY_DELICATE_PINE_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_LOG]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31991 },
			enemies: [GameData.Enemy.DIADEM_MELIA],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_BARBGRASS]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_BARBGRASS,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31995 },
			enemies: [GameData.Enemy.DIADEM_ICETRAP],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_SILVER_GEAR]: {
		name: GameData.Item.ODDLY_DELICATE_SILVER_GEAR,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_SILVER_GEAR,
					qtyMade: 1, collectable: true,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "ed142cbb422",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_SILVERGRACE_ORE, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CLOUDSTONE, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SILEX, qty: 5 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_SILVERGRACE_ORE]: {
		name: GameData.Item.ODDLY_DELICATE_SILVERGRACE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CLOUDSTONE]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CLOUDSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { markets: { [Market.UNIVERSALIS]: 31996 }, gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }] },
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SILEX]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SILEX,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31999 },
			enemies: [GameData.Enemy.DIADEM_ICE_BOMB],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.QUARRYING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_WOLFRAM_SQUARE]: {
		name: GameData.Item.ODDLY_DELICATE_WOLFRAM_SQUARE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_WOLFRAM_SQUARE,
					qtyMade: 1, collectable: true,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "0df59d11e84",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_SCHEELITE, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CLOUDSTONE, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_PRISMSTONE, qty: 5 },
						{ item: GameData.Item.ICE_CLUSTER, qty: 3 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_SCHEELITE]: {
		name: GameData.Item.ODDLY_DELICATE_SCHEELITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_PRISMSTONE]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_PRISMSTONE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 32000 },
			enemies: [GameData.Enemy.DIADEM_ZOBLYN],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.QUARRYING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_CELESTINE]: {
		name: GameData.Item.ODDLY_DELICATE_CELESTINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_CELESTINE,
					qtyMade: 1, collectable: true,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "4cfeab87a79",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_RAW_CELESTINE, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SILEX, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_BARBGRASS, qty: 5 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_RAW_CELESTINE]: {
		name: GameData.Item.ODDLY_DELICATE_RAW_CELESTINE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_GAZELLE_LEATHER]: {
		name: GameData.Item.ODDLY_DELICATE_GAZELLE_LEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_GAZELLE_LEATHER,
					qtyMade: 1, collectable: true,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "4b47c5757b9",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_GAZELLE_HIDE, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_LOG, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CAIMAN, qty: 5 },
						{ item: GameData.Item.EARTH_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_GAZELLE_HIDE]: {
		name: GameData.Item.ODDLY_DELICATE_GAZELLE_HIDE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CAIMAN]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_CAIMAN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31993 },
			enemies: [GameData.Enemy.PROTO_NOCTILUCALE],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_RHEA_CLOTH]: {
		name: GameData.Item.ODDLY_DELICATE_RHEA_CLOTH,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_RHEA_CLOTH,
					qtyMade: 1, collectable: true,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "425399f2379",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_RHEA, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_COCOON, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_ICE_STALAGMITE, qty: 5 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
						{ item: GameData.Item.WIND_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_RHEA]: {
		name: GameData.Item.ODDLY_DELICATE_RHEA,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_COCOON]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_COCOON,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31994 },
			enemies: [GameData.Enemy.DIADEM_BLOATED_BULB],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.HARVESTING }],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_ICE_STALAGMITE]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_ICE_STALAGMITE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31998 },
			enemies: [GameData.Enemy.DIADEM_ICE_GOLEM],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_HOLY_WATER]: {
		name: GameData.Item.ODDLY_DELICATE_HOLY_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_HOLY_WATER,
					qtyMade: 1, collectable: true,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "2c78c1be5d1",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_MISTLETOE, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SPRING_WATER, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_RASPBERRY, qty: 5 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
						{ item: GameData.Item.LIGHTNING_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_MISTLETOE]: {
		name: GameData.Item.ODDLY_DELICATE_MISTLETOE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SPRING_WATER]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SPRING_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31997 },
			enemies: [GameData.Enemy.DIADEM_BIAST, GameData.Enemy.DIADEM_GOLEM],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }],
		},
		used: [],
	},
	[GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_RASPBERRY]: {
		name: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_RASPBERRY,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 31992 },
			enemies: [GameData.Enemy.DIADEM_WEREWOOD],
			gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_SHARK_OIL]: {
		name: GameData.Item.ODDLY_DELICATE_SHARK_OIL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.ODDLY_DELICATE_SHARK_OIL,
					qtyMade: 1, collectable: true,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "9f4e48b106e",
					itemsRequired: [
						{ item: GameData.Item.ODDLY_DELICATE_HAMMERHEAD_SHARK, qty: 1 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_SPRING_WATER, qty: 5 },
						{ item: GameData.Item.GRADE_4_ARTISANAL_SKYBUILDERS_ICE_STALAGMITE, qty: 5 },
						{ item: GameData.Item.FIRE_CLUSTER, qty: 3 },
						{ item: GameData.Item.WATER_CLUSTER, qty: 3 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 20, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_HAMMERHEAD_SHARK]: {
		name: GameData.Item.ODDLY_DELICATE_HAMMERHEAD_SHARK,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.ANNA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.DIANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.ENIE, cost: [{ price: 30, currency: GameData.Currency.SKUBUILDERS_SCRIP }] },
				{ shop: GameData.Shop.MOWEN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SANANA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 45, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.ODDLY_DELICATE_ADAMANTITE_ORE]: {
		name: GameData.Item.ODDLY_DELICATE_ADAMANTITE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.GAMMA_QUADRANT, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 36, maxQtyPerJob: 250,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_RAW_JADE]: {
		name: GameData.Item.ODDLY_DELICATE_RAW_JADE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.MINING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_2],
				jobs: [Job.MIN],
				qtyPerJob: 750,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_FEATHER]: {
		name: GameData.Item.ODDLY_DELICATE_FEATHER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.ANTITHESIS, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 36, maxQtyPerJob: 250,
			},
		],
	},
	[GameData.Item.ODDLY_DELICATE_BIRCH_LOG]: {
		name: GameData.Item.ODDLY_DELICATE_BIRCH_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { gathering: [{ found: { location: GameData.MapLocation.DIADEM, x: 0, y: 0 }, method: GameData.GatherMethod.LOGGING }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_2],
				jobs: [Job.BTN],
				qtyPerJob: 750,
			},
		],
	},
	[GameData.Item.FLINTSTRIKE]: {
		name: GameData.Item.FLINTSTRIKE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.FLINTSTRIKE, hole: GameData.Fishing.PAPPUS_TREE, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 50, maxQtyPerJob: 200,
			},
		],
	},
	[GameData.Item.PICKLED_POM]: {
		name: GameData.Item.PICKLED_POM,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: { fishingHoles: [{ fish: GameData.Fish.PICKLED_POM, hole: GameData.Fishing.DELTA_QUADRANT, bait: [GameData.Bait.SKYBALL] }] },
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_SKYSTEEL, RelicData.Part.TOOL_SKYBUILDERS, RelicData.Step.PARTS, RelicData.Task.TASK_2],
				jobs: [Job.FSH],
				qtyPerJob: 50, maxQtyPerJob: 200,
			},
		],
	},
	[GameData.Item.SANDTEAK_LOG]: {
		name: GameData.Item.SANDTEAK_LOG,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27686 },
			gathering: [{ method: GameData.GatherMethod.LOGGING, found: { location: GameData.MapLocation.LADLE, x: 16, y: 30 } }],
		},
		used: [],
	},
	[GameData.Item.TITANCOPPER_ORE]: {
		name: GameData.Item.TITANCOPPER_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27701 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.CHURCH_OF_FIRST_LIGHT, x: 35, y: 15 } }],
		},
		used: [],
	},
	[GameData.Item.TITANIUM_ORE]: {
		name: GameData.Item.TITANIUM_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12537 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.CHOCOBO_FOREST, x: 30, y: 15 } }],
		},
		used: [],
	},
	[GameData.Item.VOLCANIC_TUFF]: {
		name: GameData.Item.VOLCANIC_TUFF,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27803 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.AMITY, x: 22, y: 18 } }],
		},
		used: [],
	},
	[GameData.Item.ZONURE_SKIN]: {
		name: GameData.Item.ZONURE_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.FLAME_ZONURE],
			markets: { [Market.UNIVERSALIS]: 27735 },
			shops: [
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.HALDEN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.OVIM_WOOL_YARN]: {
		name: GameData.Item.OVIM_WOOL_YARN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27755 },
			recipes: [
				{
					itemMade: GameData.Item.OVIM_WOOL_YARN,
					qtyMade: 3,
					crafter: Job.WVR,
					level: 76,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.OVIM_FLEECE, qty: 4 },
						{ item: GameData.Item.REFINED_NATRON, qty: 1 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.EXTRA_EFFERVESCENT_WATER]: {
		name: GameData.Item.EXTRA_EFFERVESCENT_WATER,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27776 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.WILD_FETE, x: 26, y: 29 } }],
		},
		used: [],
	},
	[GameData.Item.ALA_MHIGAN_SALT_CRYSTAL]: {
		name: GameData.Item.ALA_MHIGAN_SALT_CRYSTAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 19907 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.LOCH_SELD, x: 21, y: 29 } }],
		},
		used: [],
	},
	[GameData.Item.ROYAL_GRAPES]: {
		name: GameData.Item.ROYAL_GRAPES,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27826 },
			gathering: [{ method: GameData.GatherMethod.HARVESTING, found: { location: GameData.MapLocation.DELIBERATING_DOLL, x: 15, y: 27 } }],
		},
		used: [],
	},
	[GameData.Item.MYTHRITE_ORE]: {
		name: GameData.Item.MYTHRITE_ORE,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12534 },
			gathering: [{ method: GameData.GatherMethod.MINING, found: { location: GameData.MapLocation.GORGAGNE_HOLDING, x: 31, y: 12 } }],
		},
		used: [],
	},
	[GameData.Item.MYTHRITE_SAND]: {
		name: GameData.Item.MYTHRITE_SAND,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 12531 },
			gathering: [{ method: GameData.GatherMethod.QUARRYING, found: { location: GameData.MapLocation.TWINPOOLS, x: 17, y: 13 } }],
		},
		used: [],
	},
	[GameData.Item.SEA_SWALLOW_SKIN]: {
		name: GameData.Item.SEA_SWALLOW_SKIN,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			enemies: [GameData.Enemy.TEMPEST_SWALLOW],
			markets: { [Market.UNIVERSALIS]: 27736 },
			shops: [
				{ shop: GameData.Shop.GOUSHS_OOAN, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.GRAMSOL, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
				{ shop: GameData.Shop.PEDRONILLE, cost: [{ price: 2, currency: GameData.Currency.BICOLOUR_GEMSTONE }] },
			],
		},
		used: [],
	},
	[GameData.Item.DWARVEN_COTTON_THREAD]: {
		name: GameData.Item.DWARVEN_COTTON_THREAD,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			markets: { [Market.UNIVERSALIS]: 27758 },
			recipes: [
				{
					itemMade: GameData.Item.DWARVEN_COTTON_THREAD,
					qtyMade: 3,
					crafter: Job.WVR,
					level: 78,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.DWARVEN_COTTON_BOLL, qty: 4 },
						{ item: GameData.Item.LIGHTNING_CRYSTAL, qty: 3 },
					],
				},
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CRP_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_CRP_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_BSM_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_BSM_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ARM_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_ARM_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_GSM_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_GSM_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_LTW_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_LTW_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_WVR_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_WVR_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ALC_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_ALC_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CUL_MATERIAL_A]: {
		name: GameData.Item.RESPLENDENT_CUL_MATERIAL_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.SCRIP_EXCHANGE_EULMORE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_GRIDANIA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_IDYLLSHIRE, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_LIMSA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_MOR_DHONA, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_SHARLAYAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RADZ_AT_HAN, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_RHALGRS_REACH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_CRYSTARIUM, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
				{ shop: GameData.Shop.SCRIP_EXCHANGE_ULDAH, cost: [{ price: 25, currency: GameData.Currency.SCRIP_COMMON_CRAFTER }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CRP_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_CRP_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CRP_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CRP_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_BSM_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_BSM_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_BSM_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_BSM_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ARM_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_ARM_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ARM_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ARM_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_GSM_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_GSM_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_GSM_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_GSM_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_LTW_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_LTW_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_LTW_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_LTW_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_WVR_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_WVR_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_WVR_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_WVR_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ALC_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_ALC_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ALC_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ALC_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CUL_COMPONENT_A]: {
		name: GameData.Item.RESPLENDENT_CUL_COMPONENT_A,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CUL_COMPONENT_A,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CUL_MATERIAL_A, qty: 1 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 240,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CRP_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_CRP_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CRP_COMPONENT_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_BSM_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_BSM_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_BSM_COMPONENT_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ARM_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_ARM_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ARM_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_GSM_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_GSM_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_GSM_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_LTW_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_LTW_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_LTW_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_WVR_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_WVR_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_WVR_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ALC_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_ALC_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ALC_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CUL_MATERIAL_B]: {
		name: GameData.Item.RESPLENDENT_CUL_MATERIAL_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CUL_MATERIAL_A }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CRP_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_CRP_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CRP_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CRP_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_BSM_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_BSM_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_BSM_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_BSM_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ARM_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_ARM_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ARM_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ARM_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_GSM_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_GSM_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_GSM_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_GSM_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_LTW_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_LTW_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_LTW_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_LTW_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_WVR_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_WVR_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_WVR_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_WVR_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ALC_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_ALC_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ALC_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ALC_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CUL_COMPONENT_B]: {
		name: GameData.Item.RESPLENDENT_CUL_COMPONENT_B,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CUL_COMPONENT_B,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CUL_MATERIAL_B, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_2],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 120,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CRP_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_CRP_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CRP_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_BSM_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_BSM_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_BSM_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ARM_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_ARM_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ARM_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_GSM_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_GSM_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_GSM_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_LTW_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_LTW_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_LTW_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_WVR_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_WVR_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_WVR_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_ALC_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_ALC_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ALC_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CUL_MATERIAL_C]: {
		name: GameData.Item.RESPLENDENT_CUL_MATERIAL_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CUL_COMPONENT_B }] },
			],
		},
		used: [],
	},
	[GameData.Item.RESPLENDENT_CRP_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_CRP_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CRP_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.CRP,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CRP_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.CRP],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_BSM_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_BSM_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_BSM_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.BSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_BSM_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.BSM],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ARM_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_ARM_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ARM_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.ARM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ARM_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.ARM],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_GSM_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_GSM_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_GSM_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.GSM,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_GSM_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.GSM],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_LTW_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_LTW_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_LTW_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.LTW,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_LTW_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.LTW],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_WVR_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_WVR_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_WVR_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.WVR,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_WVR_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.WVR],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ALC_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_ALC_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_ALC_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.ALC,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_ALC_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.ALC],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CUL_COMPONENT_C]: {
		name: GameData.Item.RESPLENDENT_CUL_COMPONENT_C,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			recipes: [
				{
					itemMade: GameData.Item.RESPLENDENT_CUL_COMPONENT_C,
					qtyMade: 1,
					crafter: Job.CUL,
					level: 80,
					lodestoneID: "",
					itemsRequired: [
						{ item: GameData.Item.RESPLENDENT_CUL_MATERIAL_C, qty: 2 },
					],
				},
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_3],
				jobs: [Job.CUL],
				qtyPerJob: 30, maxQtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CRP_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_CRP_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CRP_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.CRP],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_BSM_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_BSM_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_BSM_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.BSM],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ARM_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_ARM_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ARM_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.ARM],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_GSM_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_GSM_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_GSM_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.GSM],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_LTW_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_LTW_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_LTW_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.LTW],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_WVR_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_WVR_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_WVR_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.WVR],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_ALC_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_ALC_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_ALC_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.ALC],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.RESPLENDENT_CUL_MATERIAL_FINAL]: {
		name: GameData.Item.RESPLENDENT_CUL_MATERIAL_FINAL,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			shops: [
				{ shop: GameData.Shop.LIMBETH, cost: [{ price: 1, currency: GameData.Item.RESPLENDENT_CUL_COMPONENT_C }] },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_4],
				jobs: [Job.CUL],
				qtyPerJob: 60,
			},
		],
	},
	[GameData.Item.FOUND_THAT_MINER_7]: {
		name: GameData.Item.FOUND_THAT_MINER_7,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "This is an achievement - Gather 220 unique items as a Miner" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.MIN],
				qtyPerJob: 220,
			},
		],
	},
	[GameData.Item.FOUND_THAT_BOTANIST_7]: {
		name: GameData.Item.FOUND_THAT_BOTANIST_7,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "This is an achievement - Gather 340 unique items as a Botanist" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.BTN],
				qtyPerJob: 340,
			},
		],
	},
	[GameData.Item.CAUGHT_THAT_7]: {
		name: GameData.Item.CAUGHT_THAT_7,
		type: EorzeaDataType.ITEM,
		lodestoneID: "",
		obtained: {
			other: [
				{ element: "p", text: "This is an achievement - Catch 1149 unique fish as a Fisher" },
			],
		},
		used: [
			{
				relic: [RelicData.Type.TOOL, RelicData.Group.TOOL_RESPLENDENT, RelicData.Part.TOOL_RESPLENDENT, RelicData.Step.RESPLENDENT, RelicData.Task.TASK_1],
				jobs: [Job.FSH],
				qtyPerJob: 1140,
			},
		],
	},
} satisfies Partial<{ [key in GameData.Item]: Info.Item }>;
